import { createRouter, createWebHistory, RouteRecordRaw, RouterOptions } from "vue-router";
import Home from "@/views/Home.vue";
import Fehler from "@/views/Fehler.vue";
import keycloakStore from "@/businesslogic/stores/keycloakStore";
import Wiederaufnahme from "@/views/Wiederaufnahme.vue";
import RoutePHVDirekt from "@/router/routes/phv/RoutePHVDirekt";
import RoutePHVMakler from "@/router/routes/phv/RoutePHVMakler";
import RoutePHV2025Direkt from "@/router/routes/phv2025/RoutePHV2025Direkt";
import RoutePHV2025Makler from "@/router/routes/phv2025/RoutePHV2025Makler";
import RouteVGVDirekt from "@/router/routes/vgv/RouteVGVDirekt";
import RouteVGVMakler from "@/router/routes/vgv/RouteVGVMakler";
import RouteBLDirekt from "@/router/routes/bl/RouteBLDirekt";
import RouteBLMakler from "@/router/routes/bl/RouteBLMakler";
import RouteBHMakler from "@/router/routes/bh/RouteBHMakler";
import RouteBHDirekt from "@/router/routes/bh/RouteBHDirekt";
import RouteHGDirekt from "@/router/routes/hg/RouteHGDirekt";
import RouteHGMakler from "@/router/routes/hg/RouteHGMakler";
import RoutePHVMaklerLink from "@/router/routes/phv/RoutePHVMaklerLink";
import RoutePHV2025MaklerLink from "@/router/routes/phv2025/RoutePHV2025MaklerLink";
import VermittlerNummerService from "@/businesslogic/services/VermittlerNummerService";
import Logger from "js-logger";
import RouteVGVMaklerLink from "@/router/routes/vgv/RouteVGVMaklerLink";
import RouteBLMaklerLink from "@/router/routes/bl/RouteBLMaklerLink";
import RouteBHMaklerLink from "@/router/routes/bh/RouteBHMaklerLink";
import RouteHGMaklerLink from "@/router/routes/hg/RouteHGMaklerLink";
import RouteVHV2024Direkt from "@/router/routes/vhv2024/RouteVHV2024Direkt";
import RouteVHV2024Makler from "@/router/routes/vhv2024/RouteVHV2024Makler";
import RouteVHV2024MaklerLink from "@/router/routes/vhv2024/RouteVHV2024MaklerLink";
import RouteFH2024Makler from "@/router/routes/fh2024/RouteFH2024Makler";
import RouteFH2024MaklerLink from "@/router/routes/fh2024/RouteFH2024MaklerLink";
import RouteFH2024Direkt from "@/router/routes/fh2024/RouteFH2024Direkt";

function maklerPropMapping() {
  return (route: any) => ({
    inline: route.query.inline,
    isMakler: true,
    anfrageId: route.query.anfrageId,
    vorbelegungsId: route.query.vorbelegungsId,
    vermittlerNummer: route.query.vermittlerNummer,
    externeReferenz: route.query.externereferenz,
    ansprechPartner: route.query.ansprechpartner,
  });
}

function maklerLinkPropMapping() {
  return (route: any) => ({
    inline: route.query.inline,
    isMakler: true,
    isMaklerLink: true,
    anfrageId: route.query.anfrageId,
    vorbelegungsId: route.query.vorbelegungsId,
    vermittlerNummer: route.query.vermittlerNummer,
    externeReferenz: route.query.externereferenz,
    koop: route.query.koop,
    ansprechPartner: route.query.ansprechpartner,
  });
}

function direktPropMapping() {
  return (route: any) => ({
    inline: route.query.inline,
    vermittlerNummer: route.query.vermittlerNummer,
    fachbereich: "direkt",
    quelle: route.query.quelle,
  });
}

const pruefeProdukt = (path: string, produkte: string[]): boolean => {
  if (produkte === undefined || produkte === null) {
    return true;
  }

  for (const produkt of produkte) {
    Logger.debug("Prüfe Produkt", path, produkt, path.endsWith(produkt));
    if (path.endsWith(produkt)) {
      return true;
    }
  }
  return false;
};

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/wiederaufnahme/:sparte/:anfrageId/:quelle?",
    name: "Wiederaufnahme",
    props: true,
    component: Wiederaufnahme,
  },
  {
    path: "/phv",
    name: "PHV2025",
    component: () => import("@/views/phv2025/views/PHV2025.vue"),
    props: direktPropMapping(),
    children: RoutePHV2025Direkt,
  },
  {
    path: "/makler/phv",
    name: "Makler-PHV",
    component: () => import("@/views/phv2025/views/PHV2025.vue"),
    meta: {
      requiresAuth: true,
    },
    props: maklerPropMapping(),
    children: RoutePHV2025Makler,
  },
  {
    path: "/makler-tarifrechner/phv",
    name: "Makler-Tarifrechner-PHV",
    component: () => import("@/views/phv2025/views/PHV2025.vue"),
    meta: {
      requiresAuth: false,
    },
    props: maklerLinkPropMapping(),
    children: RoutePHV2025MaklerLink,
  },
  {
    path: "/phv2020",
    name: "PHV",
    component: () => import("@/views/phv/views/PHV.vue"),
    props: direktPropMapping(),
    children: RoutePHVDirekt,
  },
  {
    path: "/makler/phv2020",
    name: "Makler-PHV2020",
    component: () => import("@/views/phv/views/PHV.vue"),
    meta: {
      requiresAuth: true,
    },
    props: maklerPropMapping(),
    children: RoutePHVMakler,
  },
  {
    path: "/makler-tarifrechner/phv2020",
    name: "Makler-Tarifrechner-PHV2020",
    component: () => import("@/views/phv/views/PHV.vue"),
    meta: {
      requiresAuth: false,
    },
    props: maklerLinkPropMapping(),
    children: RoutePHVMaklerLink,
  },
  {
    path: "/makler/vgv",
    name: "Makler-VGV",
    component: () => import("@/views/vgv/views/VGV.vue"),
    meta: {
      requiresAuth: true,
    },
    props: maklerPropMapping(),
    children: RouteVGVMakler,
  },
  {
    path: "/makler-tarifrechner/vgv",
    name: "Makler-Tarifrechner-VGV",
    component: () => import("@/views/vgv/views/VGV.vue"),
    meta: {
      requiresAuth: false,
    },
    props: maklerLinkPropMapping(),
    children: RouteVGVMaklerLink,
  },
  {
    path: "/vgv",
    name: "VGV",
    component: () => import("@/views/vgv/views/VGV.vue"),
    props: direktPropMapping(),
    children: RouteVGVDirekt,
  },
  {
    path: "/vhv",
    name: "VHV2024",
    component: () => import("@/views/vhv2024/views/VHV2024.vue"),
    props: direktPropMapping(),
    children: RouteVHV2024Direkt,
  },

  {
    path: "/makler/vhv",
    name: "Makler-VHV2024",
    component: () => import("@/views/vhv2024/views/VHV2024.vue"),
    meta: {
      requiresAuth: true,
    },
    props: maklerPropMapping(),
    children: RouteVHV2024Makler,
  },
  {
    path: "/makler-tarifrechner/vhv",
    name: "Makler-Tarifrechner-VHV2024",
    component: () => import("@/views/vhv2024/views/VHV2024.vue"),
    meta: {
      requiresAuth: false,
    },
    props: maklerLinkPropMapping(),
    children: RouteVHV2024MaklerLink,
  },

  {
    path: "/makler/bl",
    name: "Makler-BL",
    component: () => import("@/views/bl/views/BL.vue"),
    meta: {
      requiresAuth: true,
    },
    props: maklerPropMapping(),
    children: RouteBLMakler,
  },
  {
    path: "/makler-tarifrechner/bl",
    name: "Makler-Tarifrechner-BL",
    component: () => import("@/views/bl/views/BL.vue"),
    meta: {
      requiresAuth: false,
    },
    props: maklerLinkPropMapping(),
    children: RouteBLMaklerLink,
  },
  {
    path: "/bl",
    name: "BL",
    component: () => import("@/views/bl/views/BL.vue"),
    props: direktPropMapping(),
    children: RouteBLDirekt,
  },

  {
    path: "/makler/bh",
    name: "Makler-BH",
    component: () => import("@/views/bh/views/BH.vue"),
    meta: {
      requiresAuth: true,
    },
    props: maklerPropMapping(),
    children: RouteBHMakler,
  },
  {
    path: "/makler-tarifrechner/bh",
    name: "Makler-Tarifrechner-BH",
    component: () => import("@/views/bh/views/BH.vue"),
    meta: {
      requiresAuth: false,
    },
    props: maklerLinkPropMapping(),
    children: RouteBHMaklerLink,
  },
  {
    path: "/bh",
    name: "BH",
    component: () => import("@/views/bh/views/BH.vue"),
    props: direktPropMapping(),
    children: RouteBHDirekt,
  },

  {
    path: "/makler/hg",
    name: "Makler-HG",
    component: () => import("@/views/hg/views/HG.vue"),
    meta: {
      requiresAuth: true,
    },
    props: maklerPropMapping(),
    children: RouteHGMakler,
  },
  {
    path: "/makler-tarifrechner/hg",
    name: "Makler-Tarifrechner-HG",
    component: () => import("@/views/hg/views/HG.vue"),
    meta: {
      requiresAuth: false,
    },
    props: maklerLinkPropMapping(),
    children: RouteHGMaklerLink,
  },
  {
    path: "/hg",
    name: "HG",
    component: () => import("@/views/hg/views/HG.vue"),
    props: direktPropMapping(),
    children: RouteHGDirekt,
  },

  {
    path: "/makler/fh",
    name: "Makler-FH2024",
    component: () => import("@/views/fh2024/views/FH2024.vue"),
    meta: {
      requiresAuth: true,
    },
    props: maklerPropMapping(),
    children: RouteFH2024Makler,
  },
  {
    path: "/makler-tarifrechner/fh",
    name: "Makler-Tarifrechner-FH2024",
    component: () => import("@/views/fh2024/views/FH2024.vue"),
    meta: {
      requiresAuth: false,
    },
    props: maklerLinkPropMapping(),
    children: RouteFH2024MaklerLink,
  },
  {
    path: "/fh",
    name: "FH2024",
    component: () => import("@/views/fh2024/views/FH2024.vue"),
    props: direktPropMapping(),
    children: RouteFH2024Direkt,
  },

  {
    path: "/fehler",
    name: "Fehler",
    component: Fehler,
    props: true,
  },
  {
    path: "/fehler/inaktiv",
    name: "FehlerInaktiv",
    component: Fehler,
    props: () => ({
      error: "Die aufgerufene Seite steht derzeit nicht zur Verfügung.",
    }),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "FehlerNichtGefunden",
    component: Fehler,
    props: () => ({
      error: "Die aufgerufene Seite wurde nicht gefunden.",
    }),
  },
];

function fuegeRoutenPrefixAlsAliasHinzu(routen: Array<RouteRecordRaw>): Array<RouteRecordRaw> {
  if (process.env.VUE_APP_ROUTEN_PREFIX) {
    for (const route of routen) {
      route.alias = process.env.VUE_APP_ROUTEN_PREFIX + route.path;
    }
  }
  return routen;
}

const router = createRouter(<RouterOptions>{
  history: createWebHistory(process.env.VUE_APP_ROUTEN_PREFIX + "/"),
  routes: fuegeRoutenPrefixAlsAliasHinzu(routes),
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    const keycloak = keycloakStore().getKeycloakData();

    if (keycloak.token === undefined) {
      keycloak.login();
      next();
    } else {
      next();
    }
  } else if (to.path.includes("makler-tarifrechner/")) {
    if (from.path.includes("makler-tarifrechner/")) {
      next();
    } else {
      if (
        to.query.vermittlerId === null ||
        to.query.vermittlerId === undefined ||
        to.query.externereferenz === null ||
        to.query.externereferenz === undefined
      ) {
        next({ name: "Fehler" });
      } else {
        VermittlerNummerService.ladeVermittlernummerFuerMaklerLink(to.query.vermittlerId.toString())
          .then((res) => {
            Logger.debug("MaklerLink", to, res.data.vermittlernummer, res.data.produkte);
            to.query.vermittlerNummer = res.data.vermittlernummer;
            if (pruefeProdukt(to.path, res.data.produkte)) {
              next();
            } else {
              next({ name: "Fehler" });
            }
          })
          .catch((err) => {
            Logger.debug("Fehler beim laden der Vermittlernummer" + err);
            next({ name: "Fehler" });
          });
      }
    }
  } else {
    next(); // make sure to always call next()!
  }
});

router.beforeResolve((to, from, next) => {
  if (process.env.VUE_APP_ROUTEN_GESPERRT.split(",").includes(to.path)) {
    next({ name: "FehlerInaktiv" });
  }

  next();
});

export default router;
